import { useCallback } from 'react'
import { isNull } from 'lodash-es'
import { useDispatch, useSelector } from 'react-redux'

import { actionNames } from '../shared/actions.playback'
import { getPlaybackPosition } from '../utils/persistPlaybackPosition'
import {
  usePlaybackState,
  setPlaybackState,
  setPlaybackSettings,
} from '../../firebase/hooks/useVideoPlayback'

const getLoppingIds = (state) => state.webinarPlayback.loopingPhotoIds
const getPlayingVideoIsPaused = (state) =>
  state.webinarPlayback.playingVideoIsPaused

// TODO: consider killing this guy
const usePlaybackIntent = () => {
  const playbackState = usePlaybackState()
  const dispatch = useDispatch()
  const loopingIds = useSelector(getLoppingIds)
  const playingVideoIsPaused = useSelector(getPlayingVideoIsPaused)

  const setPlaybackPlayIntent = useCallback(
    (video) => {
      dispatch({ type: actionNames.VIDEO_SELECTED_FOR_PLAYBACK, video })

      const photoId = video.photo_id || video.key
      const videoUrl =
        video.video_1080p_download ||
        video.video_hd_download ||
        video.video_medium_download

      setPlaybackState('play_intent_sent', {
        url: videoUrl,
        photoId,
        startPosition: getPlaybackPosition(photoId),
      })

      setPlaybackSettings({ shouldLoop: loopingIds.has(photoId) })
    },
    [loopingIds, dispatch]
  )

  const setPlaybackStopIntent = useCallback(() => {
    if (!isNull(playbackState)) {
      setPlaybackState('stop_intent_sent')

      dispatch({ type: actionNames.VIDEO_PLAYBACK_STOPPED })
    }
  }, [playbackState, dispatch])

  const setPlaybackPauseIntent = () => setPlaybackState('pause_intent_sent')

  const setPlaybackResumeIntent = () => setPlaybackState('resume_intent_sent')

  const setPlaybackScrubIntent = (newPosition) =>
    setPlaybackState('scrub_intent', {
      newPosition,
    })

  const togglePlayback = useCallback(() => {
    if (playingVideoIsPaused) {
      /*
       * Update store so component updates quickly with the new state
       */
      dispatch({ type: actionNames.UNPAUSE_VIDEO })
      setPlaybackState('resume_intent_sent')
    } else {
      dispatch({ type: actionNames.PAUSE_VIDEO })
      setPlaybackState('pause_intent_sent')
    }
  }, [dispatch, playingVideoIsPaused])

  return {
    setPlaybackPlayIntent,
    setPlaybackStopIntent,
    setPlaybackPauseIntent,
    setPlaybackResumeIntent,
    setPlaybackScrubIntent,
    togglePlayback,
  }
}

export default usePlaybackIntent
